import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { Investment } from '../../Models/Models/PortfolioAnalysis/Investment/Investment';

declare var IS_RUNNING_IN_APP_POOL;

export class TransferInRequestClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(clAccountId: string, cgtExempt: boolean): Promise<Array<Investment>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transfer/TransferInRequest/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { clAccountId: clAccountId, cgtExempt: cgtExempt }

    return AjaxWrapper.get<Array<Investment>, any>(url, data);
  }
}

